import { combineEpics } from 'redux-observable';
export default combineEpics();
